import { Routes } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';

import { permissions } from '../../permissions';
import { AuthGuardService as AuthGuard } from '../../auth-guard.service';
import { MasterDataComponent } from './master-data/master-data.component';
import { MasterDataFormComponent } from './master-data/master-data-form/master-data-form.component';
import { RackComponent } from './rack/rack.component';
import { RackFormComponent } from './rack/rack-form/rack-form.component';
import { MasterCustomerComponent } from './master-customer/master-customer.component';
import { MasterCustomerFormComponent } from './master-customer/master-customer-form/master-customer-form.component';
import { PlantComponent } from './plant/plant.component';
import { PlantFormComponent } from './plant/plant-form/plant-form.component';
import { QuickOrderComponent } from './quick-order/quick-order.component';
import { ScannedDataComponent } from './scanned-data/scanned-data.component';
import { ScannedDataFormComponent } from './scanned-data/scanned-data-form/scanned-data-form.component';
import { PartUsageComponent } from './part-usage/part-usage.component';
import { UsageReportComponent } from './usage-report/usage-report.component';
import { MasterDataImportQueueComponent } from './master-data/master-data-import-queue/master-data-import-queue.component';
import { UsageStatsComponent } from './usage-stats/usage-stats.component';
import { UsageMonthlyComponent } from './usage-monthly/usage-monthly.component';

export const routes: Routes = [
  {
    path: 'order-entry-system/master-data',
    component: MasterDataComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Master Data',
      permissions: {
        only: [permissions.OES_MASTER_DATA],
      },
    },
  },
  {
    path: 'order-entry-system/master-data/edit/:id',
    component: MasterDataFormComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Master Data Edit',
      permissions: {
        only: [permissions.OES_MASTER_DATA_EDIT],
      },
    },
  },
  {
    path: 'order-entry-system/master-data/view/:id',
    component: MasterDataFormComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Master Data View',
      permissions: {
        only: [permissions.OES_MASTER_DATA],
      },
    },
  },
  {
    path: 'order-entry-system/master-data/add',
    component: MasterDataFormComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Master Data Add',
      permissions: {
        only: [permissions.OES_MASTER_DATA_ADD],
      },
    },
  },
  {
    path: 'order-entry-system/master-data/import-queue',
    component: MasterDataImportQueueComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Master Data Import Queue',
      permissions: {
        only: [permissions.OES_MASTER_DATA_IMPORT],
      },
    },
  },
  {
    path: 'order-entry-system/racks',
    component: RackComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Rack',
      permissions: {
        only: [permissions.OES_RACK],
      },
    },
  },
  {
    path: 'order-entry-system/rack/add',
    component: RackFormComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Rack add',
      permissions: {
        only: [permissions.OES_RACK_ADD],
      },
    },
  },
  {
    path: 'order-entry-system/rack/edit/:id',
    component: RackFormComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Rack edit',
      permissions: {
        only: [permissions.OES_RACK_EDIT],
      },
    },
  },
  {
    path: 'order-entry-system/plants',
    component: PlantComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Plant',
      permissions: {
        only: [permissions.OES_PLANTS],
      },
    },
  },
  {
    path: 'order-entry-system/plant/add',
    component: PlantFormComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Add plant',
      permissions: {
        only: [permissions.OES_PLANTS_ADD],
      },
    },
  },
  {
    path: 'order-entry-system/plant/edit/:id',
    component: PlantFormComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Edit plant',
      permissions: {
        only: [permissions.OES_PLANTS_EDIT],
      },
    },
  },
  {
    path: 'order-entry-system/master-customers',
    component: MasterCustomerComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Master Customers',
      permissions: {
        only: [permissions.OES_MASTER_CUSTOMER_READ],
      },
    },
  },
  {
    path: 'order-entry-system/master-customers/edit/:id',
    component: MasterCustomerFormComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Master Customer Edit',
      permissions: {
        only: [permissions.OES_MASTER_CUSTOMER_EDIT],
      },
    },
  },
  {
    path: 'order-entry-system/replenishment-order',
    component: QuickOrderComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Replenishment Order',
      permissions: {
        only: [permissions.OES_SAVED_DATA_READ],
      },
    },
  },
  {
    path: 'order-entry-system/consumption-order',
    component: QuickOrderComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Consumption Order',
      permissions: {
        only: [permissions.OES_SAVED_DATA_READ],
      },
    },
  },
  {
    path: 'order-entry-system/receiving-order',
    component: QuickOrderComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Receiving Order',
      permissions: {
        only: [permissions.OES_SAVED_DATA_READ],
      },
    },
  },
  {
    path: 'order-entry-system/scanned-data',
    component: ScannedDataComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Scanned Data',
      permissions: {
        only: [permissions.OES_SCANNED_DATA],
      },
    },
  },
  {
    path: 'order-entry-system/scanned-data/view/:id',
    component: ScannedDataFormComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Scanned Data View',
      permissions: {
        only: [permissions.OES_VIEW_REPLENISHMENT_SCANS],
      },
    },
  },
  {
    path: 'order-entry-system/scanned-data/edit/:id',
    component: ScannedDataFormComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Scanned Data Edit',
      permissions: {
        only: [permissions.OES_VIEW_REPLENISHMENT_SCANS],
      },
    },
  },
  {
    path: 'order-entry-system/consumption-data',
    component: ScannedDataComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Consumption Data',
      permissions: {
        only: [permissions.OES_SCANNED_DATA],
      },
    },
  },
  {
    path: 'order-entry-system/consumption-data/view/:id',
    component: ScannedDataFormComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Consumption Data View',
      permissions: {
        only: [permissions.OES_SCANNED_DATA],
      },
    },
  },
  // {
  //     path: 'order-entry-system/consumption-data/edit/:id',
  //     component: ScannedDataFormComponent,
  //     canActivate: [AuthGuard, NgxPermissionsGuard],
  //     data: {
  //         title: 'Consumption Data Edit',
  //         permissions: {
  //             only: [permissions.OES_SCANNED_DATA_EDIT]
  //         }
  //     }
  // },
  {
    path: 'order-entry-system/receiving-data',
    component: ScannedDataComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Receiving Data',
      permissions: {
        only: [permissions.OES_SCANNED_DATA],
      },
    },
  },
  {
    path: 'order-entry-system/receiving-data/view/:id',
    component: ScannedDataFormComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Receiving Data View',
      permissions: {
        only: [permissions.OES_SCANNED_DATA],
      },
    },
  },
  // {
  //     path: 'order-entry-system/receiving-data/edit/:id',
  //     component: ScannedDataFormComponent,
  //     canActivate: [AuthGuard, NgxPermissionsGuard],
  //     data: {
  //         title: 'Receiving Data Edit',
  //         permissions: {
  //             only: [permissions.OES_SCANNED_DATA_EDIT]
  //         }
  //     }
  // },
  {
    path: 'order-entry-system/part-usage',
    component: PartUsageComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Part Usage By Date',
      permissions: {
        only: [permissions.OES_USAGE_REPORT],
      },
    },
  },
  {
    path: 'order-entry-system/usage-report',
    component: UsageReportComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Usage Charts',
      permissions: {
        only: [permissions.OES_USAGE_REPORT],
      },
    },
  },
  {
    path: 'order-entry-system/usage-stats',
    component: UsageStatsComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Usage Analysis',
      permissions: {
        only: [permissions.OES_USAGE_REPORT],
      },
    },
  },
  {
    path: 'order-entry-system/usage-monthly',
    component: UsageMonthlyComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      title: 'Usage Analysis Monthly',
      permissions: {
        only: [permissions.OES_USAGE_REPORT],
      },
    },
  },
];



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/views/oes/oes.routing.ts